import { useState } from "react";
import { toast } from "react-hot-toast";
import { useDeleteVideoMutation } from "@features/videos/videosApi";
import {
  useDeleteAssignmentMutation,
  useGetAssignmentsQuery,
} from "@features/assignments/assignmentsApi";
import {
  useDeleteQuizMutation,
  useGetQuizzesQuery,
} from "@features/quizzes/quizzesApi";
import VideoModal from "../Modals/VideoModal";
import DeleteIcon from "@admin/components/SVG/DeleteIcon";
import EditIcon from "@admin/components/SVG/EditIcon";

const Video = ({ video }) => {
  const { id, title, description } = video || {};

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  function closeModal() {
    setIsModalOpen(false);
  }

  const { data: assignments } = useGetAssignmentsQuery();

  const { data: quizzes } = useGetQuizzesQuery();

  const [deleteVideo] = useDeleteVideoMutation();

  const [deleteAssignment] = useDeleteAssignmentMutation();

  const [deleteQuiz] = useDeleteQuizMutation();

  const handleDelete = async () => {
    const response = await deleteVideo(id);

    if (response?.data) {
      toast.success("Video deleted successfully!");

      // Delete the assignment and quiz objects related to the video being deleted
      const videoAssignments = assignments.filter(
        (assignment) => assignment.video_id === id
      );

      const videoQuizzes = quizzes.filter((quiz) => quiz.video_id === id);

      for (const assignment of videoAssignments) {
        await deleteAssignment(assignment.id);
      }

      for (const quiz of videoQuizzes) {
        await deleteQuiz(quiz.id);
      }
    } else {
      toast.error("Video deleted failed!");
    }
  };

  const handleEdit = () => {
    openModal(id);
  };

  return (
    <tr>
      <td className="table-td">{title}</td>
      <td className="table-td text-truncate">{description}</td>
      <td className="table-td flex gap-x-2">
        <button onClick={handleDelete}>
          <DeleteIcon />
        </button>
        <button onClick={handleEdit}>
          <EditIcon />
        </button>
        <VideoModal videoId={id} open={isModalOpen} closeModal={closeModal} />
      </td>
    </tr>
  );
};

export default Video;
